module.exports = __webpack_public_path__ + "public/images/search.b77a66dd4ec485d4d435f7642da0de06.svg";